import React, { useEffect, useState, useRef } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "./AuthProvider";
import { Button, message, Spin, Card, Space, Divider, Input } from 'antd';
import {
    SendOutlined, MessageOutlined
} from '@ant-design/icons';
import axios from 'axios';


const Chat = () => {
    const auth = useAuth();
    const backend = window.BACKEND + "/chat";
    const [sendDisabled, setSendDisabled] = useState(true);
    const [typing, setTyping] = useState(false);
    const [loaded, setLoaded] = useState(false);
    const [mesaje, setMesaje] = useState([]);

    const messagesEndRef = useRef(null);
    const textinputRef = useRef(null);

    const scrollToBottom = () => {
        messagesEndRef.current?.scrollIntoView({ behavior: "instant" });
        textinputRef.current.focus();
    }

    const [txt, setTxt] = useState("");

    const sendMessage = (msg) => {

        setSendDisabled(true);

        if (msg != "!") {
            setTyping(true);

            var m = [...mesaje, { text: msg, user: { id: auth.token, name: auth.sesiune.nume } }];
            setMesaje(m);

        }

        if (msg == "!close") {
            var s = auth.sesiune;
            s.deschisa = 0;
            auth.setSesiune(s);
        }

        axios.post(backend + "/mesaj", { token: auth.token, m: msg })
            .then(function (res) {
                var r = res.data;

                if (r.deschisa == 0) {
                    var s = auth.sesiune;
                    s.deschisa = 0;
                    auth.setSesiune(s);
                }

                setMesaje(r.mesaje);
            })
            .catch(function (r) {
                message.warning("A aparut o eroare la trimiterea mesajului tau. Te rog sa incerci din nou!");
            }).finally(() => {
                setSendDisabled(false);
                setTyping(false);
            });
    }


    useEffect(() => {
        if (auth.token != "")
            setLoaded(true);
    }, [auth.token]);

    useEffect(() => {
        if (loaded == true)
            sendMessage("!");
    }, [loaded]);

    useEffect(() => {
        scrollToBottom()
    }, [mesaje, typing]);


    if (auth.token == "")
        return <Spin />

    // <Button onClick={() => { window.location = '/openSession?submissionId=xtest' }}>Deschide o noua conversație</Button>
    return <div>

        <Card title="Asistență 4Secunde" size="small" style={{ 'height': 'calc(100vh - 60px)' }}>
            <div style={{ margin: 5, height: 'calc(100vh - 175px)' }}>
                <div style={{ display: 'flex', padding: "5px", flexDirection: 'column', boxSizing: "border-box", height: '100%', gap: '5px', overflowY: 'auto' }}>
                    {
                        mesaje.length == 0 ? <>
                            <div className="chatItemBoxLeft">
                                <Spin /> &nbsp;&nbsp; Se deschide discuția, te rog să aștepți câteva secunde...
                            </div>
                        </> : ""
                    }

                    {mesaje.map(m => {
                        if (m.user.id == "4s")
                            return <div className="chatItemBoxLeft">

                                <div style={{ display: "inline" }}>
                                    <div className="chatUser">{m.user.name}</div>
                                    <div className="chatItem">
                                        {m.text}
                                    </div>
                                </div>


                            </div>
                        else
                            return <div className="chatItemBoxRight ">
                                <div style={{ display: "inline" }}>
                                    <div className="chatUser">{m.user.name}</div>
                                    <div className="chatItem chatSourceUser">
                                        {m.text}
                                    </div>
                                </div>
                            </div>
                    })}

                    {typing ? <>
                        <div className="chatItemBoxLeft">
                            <div className="chatUser">4Secunde scrie un mesaj...</div>

                        </div>
                    </> : ""}

                    <div ref={messagesEndRef} />

                </div>
            </div>
            <Divider style={{ margin: "10px" }} />
            <Input ref={textinputRef} disabled={auth.sesiune.deschisa ? ((typing || sendDisabled) ? true : false) : true} addonBefore={<MessageOutlined />} value={txt} onPressEnter={() => { sendMessage(txt); setTxt(""); }} onChange={(e) => { setTxt(e.target.value); }}
                addonAfter={<SendOutlined onClick={() => { sendMessage(txt); setTxt(""); }} />} />
        </Card>
        <div style={{ "marginTop": "5px" }}>
            {auth.sesiune.deschisa && !sendDisabled ?
                <Button disabled={typing ? true : false} onClick={() => { sendMessage("!close"); }}>Închide conversația</Button>
                :
                ""
            }
        </div>
    </div >

};

export default Chat;
